import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {DocumentsService} from "../../../../../../services/document.service";
import {suplementosBase, SuplementoModel} from "../../../../../../models/suplemento.model";
import {NgForOf, NgIf} from "@angular/common";
import {environment} from "../../../../../../../environments/environment";
import Swal from "sweetalert2";

@Component({
  selector: 'app-suplementacion',
  standalone: true,
  imports: [
    NgForOf,
    NgIf
  ],
  templateUrl: './suplementacion.component.html',
  styleUrl: './suplementacion.component.css'
})
export class SuplementacionComponent implements OnInit, OnChanges{

  constructor(
      private documentService: DocumentsService,
  ) { }
  @Input({required: true}) userInfo: any;
  @Input({required: true}) detallePrograma: any;
  @Input({required: true}) detalleCliente: any;

  listaSuplementosBase: any = suplementosBase
  listaPlanSuplementacion: any = []
  programaActivo: any = {}
  fechaActual: string;
  mostrarAlerta: any = true

  ngOnInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("=========================== onChanges Expediente Desde suplementacion=======================================")
    if(typeof this.detalleCliente == 'undefined'){
      this.mostrarAlerta = true
    }else{
      this.mostrarAlerta = false
      // obtiene fecha actual
      const today = new Date();
      const yyyy = today.getFullYear();
      let mm: any = today.getMonth() + 1; // Months start at 0!
      let dd: any = today.getDate();

      if (dd < 10){ dd = '0' + dd; }
      if (mm < 10){ mm = '0' + mm; }
      this.fechaActual = mm + '/' + dd + '/' + yyyy;

      //this.obtieneProgramaActivo()
      this.programaActivo = this.obtieneProgramaActivo(this.detalleCliente)
      this.formatoFechas()
    }

  }

  agregarSuplemento(suplemento, indexBase){
      this.listaPlanSuplementacion.push(suplemento);
      this.listaSuplementosBase.splice(indexBase, 1);

      this.actualizarPrograma(suplemento)
  }

  eliminarSuplemento(suplemento, indexBase){
    this.listaSuplementosBase.push(suplemento);
    this.listaPlanSuplementacion.splice(indexBase, 1);

    this.actualizarPrograma(suplemento)
  }

  actualizarPrograma(suplemento){
    // conversion fecha actual string a date
    let dateActual = new Date(this.fechaActual);

    for(let i in this.programaActivo.configuracionMacrosXdia){

      // conversion de fecha de cada dia del programa a formato date para poder comparar
      let dateString = this.programaActivo.configuracionMacrosXdia[i].fecha;
      let dateParts = dateString.split("-");
      let dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

      if(dateActual <= dateObject){
        this.programaActivo.configuracionMacrosXdia[i].planSuplementacion = this.listaPlanSuplementacion
      }
    }

    this.ejecutaGuardarPrograma()
  }

  ejecutaGuardarPrograma(){

    for(let k in this.detalleCliente.expediente.programas){
      if(this.detalleCliente.expediente.programas[k].configuracionPrograma.id == this.programaActivo.configuracionPrograma.id){
        this.detalleCliente.expediente.programas[k] = this.programaActivo
      }
    }

    let clienteDocumentModel = {
      expediente: {
        programas: this.detalleCliente.expediente.programas
      }
    }
    // Actualizar el expediente del cliente
    this.documentService.updateDocumentInContainer(
        environment.businessId,
        this.userInfo.documentContainerId,
        this.detalleCliente.documentId,
        'cliente',
        null,
        clienteDocumentModel
    ).subscribe({
      next: (data: any) => {
        //mensaje exito

        this.listaSuplementosBase.sort((firstObject, secondObject) => (firstObject.nombre > secondObject.nombre) ? 1 : -1);
        this.listaPlanSuplementacion.sort((firstObject, secondObject) => (firstObject.nombre > secondObject.nombre) ? 1 : -1);
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        // Swal.fire({
        //   toast: true, // Activa el estilo tipo Toast
        //   position: 'bottom-end', // Posición del mensaje
        //   icon: 'success',
        //   title: 'Suplementación actualizada con éxito.',
        //   showConfirmButton: false,
        //   timer: 3000, // Tiempo de duración del mensaje (5 segundos)
        //   timerProgressBar: true // Muestra una barra de progreso
        // });
      }
    })
  }

  obtieneProgramaActivo(cliente){
    // agregar logica para obtener el programa activo
    let programaActivo = null;
    const hoy = new Date();
    cliente.expediente?.programas.forEach((programa: any) => {
      const fechaInicio = new Date(programa.periodos[0].fechaInicioDate);
      const fechaFin = new Date(programa.periodos[programa.periodos.length - 1].fechaFinDate);
      if (hoy >= fechaInicio && hoy <= fechaFin) {
        programaActivo = programa;
      }
    });

    if(programaActivo == null){
      programaActivo = cliente.expediente.programas[cliente.expediente.programas.length - 1]
    }

    return programaActivo;
  }

  formatoFechas(){
    this.listaPlanSuplementacion = [];
    // no funcionó la comparación de fechas con el mismo formato, para esta funcion cambio la forma de comparar la fecha actual
    let fechaActual = this.fechaActual.split("/");
    let fechaActualFormateada =  fechaActual[1] +  '-' + fechaActual[0] + '-' + fechaActual[2];
    let dateActual = new Date(this.fechaActual);
    for(let i in this.programaActivo.configuracionMacrosXdia){
      if(fechaActualFormateada == this.programaActivo.configuracionMacrosXdia[i].fecha){
        let objDiaActual: any = {}
        objDiaActual = this.programaActivo.configuracionMacrosXdia[i];
        if(objDiaActual.planSuplementacion){
          this.listaPlanSuplementacion = objDiaActual.planSuplementacion
        }
      }
    }

    // limpiar el array de suplementos base, quitando los de la lista de plan de suplementacion
    for(let j in this.listaPlanSuplementacion){
      for(let k in this.listaSuplementosBase){
        if(this.listaPlanSuplementacion[j].nombre == this.listaSuplementosBase[k].nombre){
          this.listaSuplementosBase.splice(k, 1);
        }
      }
    }
    this.listaSuplementosBase.sort((firstObject, secondObject) => (firstObject.nombre > secondObject.nombre) ? 1 : -1);
    this.listaPlanSuplementacion.sort((firstObject, secondObject) => (firstObject.nombre > secondObject.nombre) ? 1 : -1);
  }


}
